import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import FetchApi from '../customhooks/functionFetchApi';
import { createDuplicate } from './service/serviceduplicagte';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Viewduplicatedetail from './components/viewduplicatedetails';
import {
    FaSearch
} from "react-icons/fa";

function createjournalduplicate(journalId) {

    Swal.fire({
        title: "สร้างเอกสาร",
        text: "คุณแน่ใจที่สร้างเอกสาร ใช่หรือไม่ ! ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ใช่",
        cancelButtonText: 'ยกเลิก'
    }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire({
                title: "สร้างเอกสาร!",
                text: "คุณได้สร้างเอกสารเรียบแล้ว",
                icon: "success"
            });
            //   loadingdata();
            createDuplicate(journalId);

            toast.success('บันทึกเรียบร้อยแล้ว', {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                // transition: Bounce,
            });

        }
    });
}


const columns = [
    {
        name: 'MK.NO',
        grow: 1,
        sortable: true,
        selector: row => row.tdscode,
    },
    {
        name: 'Film code',
        grow: 1,
        selector: row => row.fname,
    },
    {
        name: 'filmcode',
        selector: row => row.filmcode,
    },
    {
        name: 'customername',
        grow: 1.5,
        selector: row => row.customername,
    },
    {
        name: 'Action',
        grow: 1.5,
        cell: row => <div className='row-page'>
            {/* <Button size='sm' variant="success" onClick={() => createjournalduplicate(row.journalId)} style={{ marginRight: 10 }}>สร้างเอกสาร</Button> */}
            < Viewduplicatedetail jourId={row.journalId} JournalTDS={row.tdscode} />
        </div>,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};

const FormAtable = ({ dataList }) => {
    var dataresult = dataList;

    return (
        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}



// list film code  to create 
function Listfilmcode(props) {

    const FetchApis = new FetchApi();
    const [inputText, setInputText] = useState("")
    const [datafilmcode, setDatafilmcode] = useState([]);
    const [searchText, setSeachText] = useState([]);

    useEffect(() => {
        getlistFilmcode()
    }, [])

    const getlistFilmcode = () => {
        FetchApis.FethcGet(`/journal/getsearchfilmcode`).then(res => {
            if (res) {
                // console.log(res.data.data)
                setDatafilmcode(res.data.data);
                setSeachText(res.data.data);
            }
        })
    }


    function isfilmcode(datafilm) {
        props.isseleteFilmcode(datafilm)
        props.handleShow(false)

    }

    function isSearchText(datavalue) {
        const filteredData = searchText.filter((item) => {
            return Object.values(item).join('').toLowerCase().includes(datavalue.toLowerCase())
        })
        setDatafilmcode(filteredData);
    }


    const columns = [
        {
            name: 'MK.NO',
            grow: 1,
            sortable: true,
            selector: row => row.tdscode,
        },
        {
            name: 'Film code',
            grow: 1,
            selector: row => row.fname,
        },
        {
            name: 'filmcode',
            selector: row => row.filmcode,
        },
        {
            name: 'customername',
            grow: 1.5,
            selector: row => row.customername,
        },
        {
            name: 'Action',
            grow: 1.5,
            cell: row => <div className='row-page'>
                <Button variant="success" size='sm'
                    onClick={() => isfilmcode(row.filmcode)}
                    style={{ marginRight: 10 }}>เลือก film</Button>
                {/* <Button size='sm' variant="success" onClick={() => createjournalduplicate(row.journalId)} style={{ marginRight: 10 }}>สร้างเอกสาร</Button> */}
                < Viewduplicatedetail jourId={row.journalId} JournalTDS={row.tdscode} />
            </div>,
        },

    ];

    return (
        <div>
            <div style={{padding:10,margin:5}}>
                <input type='text' onChange={(e) => isSearchText(e.target.value)}  placeholder='ค้นหา'/>
            </div>
            <div>
                <DataTable
                    columns={columns}
                    data={datafilmcode}
                    pagination
                    customStyles={customStyles}
                    highlightOnHover
                />
            </div>
        </div>
    )
}



const DuplicateByfilmcode = (props) => {

    const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down'];
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);

    function handleShow(value) {
        // setFullscreen(breakpoint);
        setShow(value);
    }

    return (
        <div>
            <label style={{
                fontSize: 10, padding: 3, backgroundColor: '#F0BE08',
                borderRadius: 5, borderColor: '#E3B405', marginLeft: 5, color: '#ffff'
            }} onClick={() => handleShow(true)} >
                <FaSearch /> Film Code
            </label>

            <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>ข้อมูล Film Code </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Listfilmcode isseleteFilmcode={props.isseleteFilmcode} handleShow={handleShow} />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default DuplicateByfilmcode